import BlogCardHorizontal from "@components/BasicComponents/Cards/BlogCard/BlogCardHorizontal"
import {useLocale} from "@components/Contexts/LocaleContext"
import Description from "@components/CustomTypography/Description/Description"
import Paragraph from "@components/CustomTypography/Paragraph/Paragraph"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import ButtonComponent from "@components/Theme/Button/Button"
import {getPosts} from "@config/modules"
import {getLink} from "@hooks/PagesData/getLink"
import {checkIfInBlogCategory} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyAdditionalFunctions"
import {CategoryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Blogsjson from "@jsons/blogPosts.json"
import Error from "next/error"
import React from "react"

import styles from "./Post.module.scss"
import {PostComponent} from "./PostComponent"

// TODO: Create Normal Template when we will get the design
const Post = (props: PostComponent) => {
	const {changeLocale: changeLocaleCustome} = useLocale()

	// Trow 404 page for unExist pages
	// ! Required for avoiding errors on server side rendering
	if (!props.data.post) {
		return <Error statusCode={404} />
	}
	const BlogPosts = getPosts("BlogPostsModule", {data: Blogsjson})
	changeLocaleCustome(props.data.post.lang)

	const data = props.data.post

	let blogData = BlogPosts
	const categories = data.category.map(
		(element: CategoryModuleType, index: number) => {
			return element.slug
		},
	)

	if (typeof blogData !== "undefined") {
		blogData = BlogPosts.filter(
			(element: any) => element.slug !== data.slug,
		)
		const FilteredBlogData = checkIfInBlogCategory(blogData, categories)

		if (FilteredBlogData.length > 0) {
			blogData = FilteredBlogData

			if (FilteredBlogData.length === 1) {
				blogData.push(
					BlogPosts.filter(
						(element: any) =>
							element.slug !== data.slug &&
							element.slug !== blogData[0].slug,
					)[0],
				)
			}
		}
	}

	return (
		<>
			<div className={styles.post__container}>
				<div>
					<Separator>
						<Title
							capitalize={false}
							className={styles.title}
							content={data.title}
							fontWeight={600}
							size={"M"}
							type={"1"}
						/>
						<Paragraph
							content={
								<>
									Posted on: {data.upperTitle}
									{data.category.map(
										(
											element: CategoryModuleType,
											index: number,
										) => {
											return (
												<React.Fragment key={index}>
													|
													<ButtonComponent
														buttonType={"unstyled"}
														className={
															styles.categories
														}
														link={
															getLink(
																"newsArchive",
															) +
															"/?category=" +
															element.slug +
															getLink(
																"startOfPaginatoinM",
															)
														}
														asLink
													>
														{element.title}
													</ButtonComponent>
												</React.Fragment>
											)
										},
									)}
								</>
							}
							fontWeight={400}
							size={"XS"}
						/>
					</Separator>
					<div className={styles.contentContainer}>
						<Description
							content={data.content}
							fontWeight={400}
							size={"L"}
						/>
					</div>
				</div>
			</div>
			<Separator size={128}>
				<Title
					content={"More News"}
					fontWeight={600}
					size={"XL"}
					type={"2"}
					center
				/>
				{blogData.length > 0 && (
					<Separator
						className={styles.cardContainer}
						type={"padding"}
					>
						{blogData.map((element: any, index: number) => {
							if (index < 3) {
								return (
									<BlogCardHorizontal
										key={index}
										className={styles.cardBox}
										data={element}
									/>
								)
							}
							return undefined
						})}
					</Separator>
				)}
			</Separator>
		</>
	)
}

export default Post
